

































import { defineComponent, useFetch, ref, watch, onMounted } from "@nuxtjs/composition-api";
import { useSearchProducts, useUiHelpers } from "~/composables";
import { useSlickOptions } from "~/stores/extensionApi";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import CategoryProductCard from "~/modules/catalog/category/components/views/CategoryProductCard.vue";
import { useAddToCart } from "~/helpers/cart/addToCart";

export default defineComponent({
  name: "CategoryProductFace",
  components: {
    SkeletonLoader,
    ProductLoadItem,
    CategoryProductCard,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 8,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    classItem: {
      type: String,
      default: "",
    },
    classItemParent: {
      type: String,
      default: "block-product__items",
    },
    qty_product_display: {
      type: Number,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { fetchProducts, loading: loadingProduct } = useSearchProducts();
    const slickOptions = useSlickOptions();
    const { addItemToCart } = useAddToCart();

    const products = ref([]);
    const loading = ref(false);
    onMounted(async () => {
      loading.value = true;

      const itemsPerPage =
        props.qty_product_display ||
        (props.itemsPerPage ? props.itemsPerPage : 8);
      const page = props.currentPage ? props.currentPage : 1;

      const params = {
        ids: [String(props.categoryId)],
        pageSize: itemsPerPage * page,
      };
      const { data, total } = await fetchProducts(params);

      emit("getTotalItems", total);
      products.value = data ?? [];
      emit("getProductsLength", products.value.length);
      loading.value = false;
    });

    const isLoadingMore = ref(false);
    const loadMoreProducts = async () => {
      isLoadingMore.value = true;
      const itemsPerPage =
        props.qty_product_display ||
        (props.itemsPerPage ? props.itemsPerPage : 8);
      const params = {
        ids: [String(props.categoryId)],
        pageSize: itemsPerPage,
        currentPage: props.currentPage,
      };
      const { data } = await fetchProducts(params);

      const newProducts = data ?? [];
      products.value = [...products.value, ...newProducts];

      isLoadingMore.value = false;
    };

    watch(
      () => props.currentPage,
      async () => {
        await loadMoreProducts();
        emit("getProductsLength", products.value.length);
      }
    );

    return {
      slickOptions,
      products,
      loading,
      addItemToCart,
      isLoadingMore,
      loadingProduct,
    };
  },
});
